import i18n from '../config/i18n';
import { contentApi } from '../services/api/content.api';
import type { GameMode, Language } from '@business-game/shared';

const assignNested = (target: Record<string, any>, dottedKey: string, value: string) => {
  const segments = dottedKey.split('.');
  let current = target;

  for (let index = 0; index < segments.length - 1; index += 1) {
    const segment = segments[index];
    current[segment] = current[segment] || {};
    current = current[segment];
  }

  current[segments[segments.length - 1]] = value;
};

export async function applyPlayerLanguage(language?: string | null, gameMode?: GameMode | null) {
  if (!language) {
    return;
  }

  const safeLanguage = language as Language;
  if (i18n.language !== safeLanguage) {
    await i18n.changeLanguage(safeLanguage);
  }

  try {
    const bundle = await contentApi.getPublicUiBundle(safeLanguage, gameMode ?? undefined);
    const nestedBundle: Record<string, any> = {};

    Object.entries(bundle.entries).forEach(([key, value]) => {
      assignNested(nestedBundle, key, value);
    });

    i18n.addResourceBundle(safeLanguage, 'translation', nestedBundle, true, true);
  } catch (error) {
    console.error('Failed to load dynamic UI translations:', error);
  }
}
